<template>
  <div>
    <CHeader :title="title" :show="showHeader"></CHeader>
    <v-container fluid class="body">
      <v-row>
        <v-col cols="12" class="pa-0">
          <CSwiper v-if="hasSwiper" :items="swiper"></CSwiper>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="pa-0">
          <v-tabs v-model="currentTab" height="40" grow>
            <v-tab v-for="item in tabItems" :key="item">
              {{ item }}
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="currentTab" class="transparent">
            <v-tab-item>
              <CChannels
                v-if="hasOrgs"
                :items="orgList"
                @viewContent="fnGetContent"
              ></CChannels>
            </v-tab-item>
            <v-tab-item>
              <CKeywords v-if="objKeywords" :items="objKeywords"></CKeywords>
            </v-tab-item>
            <v-tab-item>
              <CChannels
                v-if="hasTreatise"
                :items="treatiseList"
                :column="2"
                category="treatise"
                @viewContent="fnGetContent"
              ></CChannels>
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
    </v-container>
    <CNav :currentNav="0"></CNav>
    <CLoading
      v-model="loading"
      :text="tipsText"
      :timeout="timeout"
      @closeDialog="loading = false"
    />
    <v-bottom-sheet v-model="showContent">
      <CContent
        v-if="currentContent"
        :item="currentContent"
        :isDialog="showContent"
        @dialogShow="fnClose"
      />
    </v-bottom-sheet>
  </div>
</template>

<script>
import { mapActions } from "vuex";
// 自定义功能
import config from "@/utils/config";
// 自定义组件
import CHeader from "@/components/c_header";
import CNav from "@/components/c_nav";
import CLoading from "@/components/c_loading";
import CSwiper from "@/components/c_swiper";
import CChannels from "@/components/c_channels";
import CKeywords from "@/components/c_keywords";
import CContent from "@/components/c_content";
export default {
  name: "Home",
  components: {
    CHeader,
    CNav,
    CLoading,
    CSwiper,
    CChannels,
    CKeywords,
    CContent,
  },
  data: () => ({
    config: config,
    tipsText: "请稍候...",
    timeout: 1000,
    loading: false,
    showHeader: false,
    title: null,
    hasSwiper: false,
    swiper: [],
    hasOrgs: false,
    orgList: [],
    hasTreatise: false,
    treatiseList: [],
    pageNum: 1,
    pageSize: 5,
    keywords: "",
    filterOrg: false,
    orgId: config.chnMember,
    orgName: "昆明市水利学会",
    showContent: false,
    currentContent: null,
    currentTab: 0,
    tabItems: ["单位", "分类", "论文"],
    objKeywords: {
      profSkill: {
        label: "专业技能",
        icon: "mdi-tag-multiple",
      },
      profTitle: {
        label: "专业职称",
        icon: "mdi-certificate",
      },
      qualification: {
        label: "学历",
        icon: "mdi-book-education-outline",
      },
      degree: {
        label: "学位",
        icon: "mdi-school",
      },
    },
  }),
  watch: {},
  mounted() {
    this.init();
  },
  methods: {
    ...mapActions(["contentsList", "stlChannels", "stlContents", "stlContent"]),
    init() {
      this.title = this.$route.meta.title;
      this.fnGetSwiper(1, 5);
      this.fnGetCategory();
      this.fnKeywordsList();
    },
    fnGetSwiper(pageNum, pageSize) {
      const that = this;
      this.loading = true;
      var params = {
        data: {
          siteId: config.siteId,
          channelId: config.chnSwiper,
          wheres: [
            {
              column: "recommend",
              operator: "=",
              value: true,
            },
            {
              column: "imageUrl",
              operator: "!=",
              value: "",
            },
          ],
          pageNum: pageNum,
          pageSize: pageSize,
        },
      };
      this.contentsList(params).then((res) => {
        that.hasSwiper = true;
        that.swiper = res.data.contents;
        that.tipsText = "完成滚动信息加载";
        that.timeout = 1000;
      });
    },
    fnGetCategory() {
      const that = this;
      // 取专家
      this.loading = true;
      var params = {
        siteId: config.siteId,
        channelId: config.chnMember,
      };
      this.stlChannels(params).then((res) => {
        that.timeout = 1000;
        that.tipsText = "完成会员单位加载";
        that.hasOrgs = true;
        that.orgList = res.data.value;
      });
      // 取论文
      this.loading = true;
      var params = {
        siteId: config.siteId,
        channelId: config.chnTreatise,
      };
      this.stlChannels(params).then((res) => {
        that.timeout = 1000;
        that.tipsText = "完成论文加载";
        that.hasTreatise = true;
        that.treatiseList = res.data.value;
      });
    },
    fnKeywordsList() {
      this.fnGetKeywords(config.chnQualification, "qualification");
      this.fnGetKeywords(config.chnDegree, "degree");
      this.fnGetKeywords(config.chnProfTitle, "profTitle");
      this.fnGetKeywords(config.chnProfSkill, "profSkill");
    },
    fnGetKeywords(channelId, key) {
      const that = this;
      this.loading = true;
      var params = {
        siteId: config.siteId,
        channelId: channelId,
        scope: "all",
      };
      this.stlContents(params).then((res) => {
        if (res.status == 200) {
          var chips = res.data.value.map((item) => {
            return {
              channelId: item.channelId,
              id: item.id,
              title: item.title,
              showMenu: false,
            };
          });
          that.objKeywords[key].values = chips;
          that.timeout = 1000;
          // console.log(that.keywordsList);
        } else {
          that.tipsText = "未找到记录";
          that.timeout = 1000;
        }
      });
    },
    fnGetContent(item) {
      const that = this;
      var params = {
        siteId: item.siteId,
        channelId: item.channelId,
        contentId: item.id,
      };
      this.stlContent(params).then((res) => {
        if (res.status == 200) {
          that.showContent = true;
          that.currentContent = res.data.value;
        }
      });
    },
    fnClose() {
      this.showContent = false;
    },
  },
};
</script>
